import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Options } from 'ng5-slider';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { ProteccionDatosComponent } from '../blocks/proteccion-datos/proteccion-datos.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { TecnologiaTcComponent } from '../blocks/tecnologia-tc/tecnologia-tc.component';
import { ConfirmacionDatosComponent } from '../blocks/confirmacion-datos/confirmacion-datos.component';

declare var fbq;
declare var gtag;
declare var ga; 

@Component({
  selector: 'app-cotizador-tecnologia',
  templateUrl: './cotizador-tecnologia.component.html',
  styleUrls: ['./cotizador-tecnologia.component.css']
})

export class CotizadorTecnologiaComponent implements OnInit {

  data: any = {};
  errors: any = [];
  path: any = "";
  waTxt: any = "";

  isLoading: boolean = false;
  cotizador: any = null;
  coberturas: any = null;
  provincias: any = null;
  ocupaciones: any = null;
  nacionalidades: any = null;
  planes: any = null;
  planSeleccionado: any = null;
  ccHorario: any = "";

  sa: number = 0;
  min_sa: number = 0;
  max_sa: number = 0;

  options: Options = {
    step: 100,
    showSelectionBar: true,
    translate: (value: number): string => {
      return '$' + value;
    }
  };

  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {

    this.path = this.route.routeConfig.path;

    this.api.getCotizador("TE").subscribe(x => {
      window.scrollTo(0, 0);
      this.cotizador = x.data;
      this.getTopes();
    });

    let tmpCanal = document.location.href.split("?");

    if (tmpCanal[1]) {
      this.data.canal = tmpCanal[1];
    }

    this.api.getHorariosCC().subscribe(x => {
      this.ccHorario = x.data.mensaje;
    });

  }

  captcha(e: any) {
    this.data.captcha = e;
  }

  selectPlan(evt: any) {
    window.scrollTo(0, 0);

    this.planSeleccionado = evt.plan;

    this.data.plan = evt.plan.productoNombre;
    this.data.cuota_mensual = evt.plan.cuota_mensual;

    this.updateLead(3);

  }

  getTopes() {
    this.api.getCoberturasTopes(this.cotizador.coberturaReferencia).subscribe(x => {

      const newOptions: Options = Object.assign({}, this.options);

      this.sa = parseInt(x.data.max) / 2;
      newOptions.ceil = parseInt(x.data.max);
      newOptions.floor = parseInt(x.data.min);
      newOptions.step = 100;

      this.options = newOptions;

      this.min_sa = x.data.min;
      this.max_sa = x.data.max;

      if(this.path == 'tecnologia'){
        this.data.step = 1;
      }

      if(this.path == 'tecnologia-gracias'){

        if (localStorage.getItem("waTxt")) {
          this.waTxt = localStorage.getItem("waTxt");
        }

        if(localStorage.getItem("tipoContacto")){
          this.data.tipo_contacto = localStorage.getItem("tipoContacto");
          this.data.step = 4;
          localStorage.removeItem("tipoContacto");
        }else{
          document.location.href="tecnologia";
        }

      }
      
      if(this.path == 'tecnologia-nps'){
        this.data.step = 5;
      }

      if(this.path == 'tecnologia-unsuscribe'){
        this.data.step = 6;
      }

           /*
        this.data.apellido = "sadf";
        this.data.email = "asdf@asdf.com";
        this.data.nombre = "sadf";
        this.data.sa = 9372;
        this.data.telefono_numero = "56322414";
        this.data.telefono_prefijo = "011";
  
        this.cotizar();

     */
    });
  }

  ngOnInit() {
  }

  goToStep(step: number, el: string = "") {
    console.log(el);
    this.data.step = step;

    if (el == "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView();
      }, 500);
    }
  }

  cotizar() {

    this.spinner.show();


    this.data.sa = this.sa;
    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        this.errors = [];
        this.data = ret.data;

        this.api.getProductosRecomendadosByCobertura(this.cotizador.coberturaReferencia, this.sa).subscribe(x => {
          this.planes = x.data;
          this.goToStep(2);
          this.spinner.hide();
        });
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.goToStep(this.data.step, "secCotizador");
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });


  }

  finalizar(tipoContacto: any) {
    this.data.tipo_contacto = tipoContacto;

    let oldEmail = this.data.email;
    let oldTelefono_prefijo = this.data.telefono_prefijo;
    let oldTelefono_numero = this.data.telefono_numero;

    if(this.data.tipo_contacto == "W"){
      this.updateLead(4);
    }

    if(this.data.tipo_contacto == "T"){

        const modalRefT = this.modalService.open(ConfirmacionDatosComponent, { size: <any>'tecno-proteccion-datos' });
        modalRefT.componentInstance.lead = this.data;
        modalRefT.componentInstance.tipo = "T";

        modalRefT.result.then((result) => {
          this.updateLead(4);
        }, (reason) => {
          this.data.telefono_prefijo = oldTelefono_prefijo;
          this.data.telefono_numero = oldTelefono_numero;
        });
    }

    if(this.data.tipo_contacto == "M"){
      const modalRefM = this.modalService.open(ConfirmacionDatosComponent, { size: <any>'tecno-proteccion-datos' });
      modalRefM.componentInstance.lead = this.data;
      modalRefM.componentInstance.tipo = "M";

      modalRefM.result.then((result) => {
        this.updateLead(4);
      }, (reason) => {
        this.data.email = oldEmail;
      });
    }


    
  }

  updateLead(stepTo: number) {
    window.scrollTo(0, 0);

    this.spinner.show();

    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        if (stepTo == 1){
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 2){
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 3) {
          fbq('track', 'Contact');
          gtag('event', 'conversion', { 'send_to': 'AW-614010822/kgjnCMLa9fIBEMaf5KQC' });
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 4) {
          fbq('track', 'Contact');
          gtag('event', 'conversion', {
            'send_to': 'AW-614010822/fyiOCIOZ5fIBEMaf5KQC',
            'transaction_id': ''
          });

          if(this.data.tipo_contacto == "W"){
            let txt = '¡Hola! Coticé mi seguro de Tecnología Protegida, el precio mensual es $' + this.data.cuota_mensual + ' por una suma asegurada de $' + this.data.sa + '. Mi ID de cotización es ' + this.data.id + '.';
            let num = '+541162217106';
            let url = 'https://wa.me/' + num + '?text=' + txt;  
            let a = document.createElement("a");

            localStorage.setItem("waTxt", txt);
            
            document.body.appendChild(a);
            a.href = url;
            a.target = "_blank";
            a.click();
            document.body.removeChild(a);

          }

          let params = {
            lead: this.data,
            cotizacion: this.cotizador,
            tipo: this.data.tipo_contacto
          }

          this.api.sendCotizacion(params).subscribe(ret => {
            localStorage.setItem("tipoContacto",this.data.tipo_contacto);
            this.spinner.hide();
            document.location.href="tecnologia-gracias";
          });


          
        }

        
      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });



  }

  showProteccionDatos() {
    this.modalService.open(ProteccionDatosComponent, { size: <any>'tecno-proteccion-datos' });
  }

  showTC() {
    this.modalService.open(TecnologiaTcComponent, { size: <any>'tecno-proteccion-datos' });
  }
}
